module.exports = "/_next/static/images/circle-6fd16eabd9a09f9f4456b710ae079ca8.png";